module.exports = __webpack_public_path__ + "media/icons/pochodzenie-kraj@2x-2d5f50d7.png";